import React, { SVGProps } from 'react'

/**
 * Feature-local lock glyph (matches the design prototype's lock icon). Lives
 * here rather than in src/components/Svgs, which `gen-svg-components` wipes and
 * regenerates from src/assets/svgs — this has no source asset.
 */
const SvgLock = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <rect
      x={3}
      y={7}
      width={10}
      height={7}
      rx={1.5}
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.3}
    />
    <path
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.3}
      d="M5 7V5a3 3 0 0 1 6 0v2"
    />
  </svg>
)
export default SvgLock
